"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _ClinicianInfoForm = _interopRequireDefault(require("./ClinicianInfoForm"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var _default = _ClinicianInfoForm.default;
exports.default = _default;